__turbopack_context__.v({
  "button": "AuthPasskey-module-scss-module__P_2xOq__button",
  "icon": "AuthPasskey-module-scss-module__P_2xOq__icon",
  "notAvailable": "AuthPasskey-module-scss-module__P_2xOq__notAvailable",
  "text": "AuthPasskey-module-scss-module__P_2xOq__text",
});
